import { type ReactNode } from 'react';
import { Modal } from './Modal';
import { Button } from './Button';
import './BasicInfoAlert.css';

interface BasicInfoAlertProps {
  isOpen: boolean;
  /** The whole dialog — there is no title, so this carries the message itself. */
  message: ReactNode;
  okLabel?: string;
  onClose: () => void;
}

/**
 * The plainest dialog there is: a message and a single OK button, no title bar.
 * For telling the user something they only have to acknowledge — replacing
 * `window.alert`, and replacing titled Modals whose title merely restated the
 * message. Built on the shared Modal, so it is themed, portalled, and dismissed
 * by Escape or the overlay as well as by OK.
 */
export function BasicInfoAlert({
  isOpen,
  message,
  okLabel = 'OK',
  onClose,
}: BasicInfoAlertProps) {
  return (
    <Modal
      isOpen={isOpen}
      onClose={onClose}
      size="sm"
      footer={
        <div className="basic-info-alert-actions">
          <Button variant="primary" onClick={onClose}>
            {okLabel}
          </Button>
        </div>
      }
    >
      <div className="basic-info-alert-message">{message}</div>
    </Modal>
  );
}
